// extracted by mini-css-extract-plugin
export var bgWrapper = "sponsorbug-module--bg-wrapper--zaOKm";
export var container = "sponsorbug-module--container--0-JUg";
export var helperText = "sponsorbug-module--helper-text--f6bnw";
export var logo = "sponsorbug-module--logo--iyhKJ";